<h2>[{{course.courseId}}] {{course.name}} ({{course.term.id}})</h2>

<app-info-box *ngIf="registration.message?.pl" [message]="registration.message"></app-info-box>

<ng-container *ngFor="let unit of course.courseUnits">
  <h3>[{{unit.classType.id}}] {{unit.classType.description}}</h3>

  <a [routerLink]="['../..']" i18n>powrót</a>
  <table class="grey">
    <thead>
    <tr class="headnote">
      <td i18n>Numer</td>
      <td i18n>Prowadzący </td>
      <td i18n>Miejsce</td>
      <td i18n>Termin</td>
      <td i18n>Liczba miejsc</td>
      <td></td>
    </tr>
    </thead>
    <tbody class="autostrong">
    <tr *ngFor="let group of unit.classGroups">
      <td>{{group.number}}
        <ng-template #tip><div class="ua-container ua-tooltip tooltip" [innerHTML]="group.description"></div></ng-template>
        <img  *ngIf="group.description?.pl" src="img/tip_info.gif" [ngbTooltip]="tip">
      </td>
      <td>
        <div *ngFor="let user of group.lecturers">
          <app-badge [user]="user"></app-badge>
        </div>
      </td>
      <td>
        <div *ngFor="let meeting of group.weeklyMeetings" >
          {{meeting.room?.building?.name?.pl}}</div>
      </td>
      <td>
        <div *ngFor="let meeting of group.weeklyMeetings">
          {{meeting.weeklyMeetingOption.day | dayOfWeek}}
          {{meeting.weeklyMeetingOption.hourBegin | number: '2.0-0' }}:{{meeting.weeklyMeetingOption.minuteBegin | number: '2.0-0' }}
          - {{meeting.weeklyMeetingOption.hourEnd | number: '2.0-0' }}:{{meeting.weeklyMeetingOption.minuteEnd | number: '2.0-0' }}</div>
      </td>
      <td>{{counter?.get(unit.id, group.number)}} / {{group.capacity}}</td>
      <td><a [routerLink]="[unit.id, group.number]" i18n>szczegóły</a></td>
    </tr>
    </tbody>
    <tr>
      <td></td>
    </tr>
  </table>

  <a [routerLink]="['../..']" i18n>powrót</a>

</ng-container>
